import template from "./templates/base-64-upload/template.html";
import { base64Config } from "./templates/base-64-upload/base-64-config";
import base64Controller from "./templates/base-64-upload/controller";
import base64Provider from "./templates/base-64-upload/provider";

export default angular
	.module("vesl.extensions.json-schema.base64FileUpload", [
		"schemaForm",
		base64Controller,
		base64Provider
	])
	.run(["$templateCache", function($templateCache) { 
		$templateCache.put("./templates/base-64-upload/template.html", template); 
	}])
	.config(base64Config)
	.name;
